import { Observable, of } from 'rxjs';
import { MockBackend } from '../mock-backend';
import { STATUS } from 'angular-in-memory-web-api';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { RequestParams } from '../mock-backend';

const payload = require('../data/mock-config.json');

export class ConfigMockService extends MockBackend {
    public static PATH: RegExp = /config/;
    public get(params: RequestParams): Observable<HttpResponse<any>> {
        return of(new HttpResponse<any>({
            body: payload,
            status: STATUS.OK,
            headers: new HttpHeaders(),
        }));
    }




}
